// Um campo somente-leitura com um dado do cliente.
//
// Os cinco rótulos do cliente (nome, endereço, complemento, observações e
// origem) eram cinco `case` iguais palavra por palavra, mudando só o valor
// mostrado e o título embaixo. Agora são este componente e cinco chamadas.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";

export const RotuloDoCliente: React.FC<{
  component: any;
  componentProps: any;
  valor: any;
  titulo: string;
}> = ({ component, componentProps, valor, titulo }) => {
  return (
    <Styles.TextInput
      selected={Boolean(component.componentSelected)}
      id={String(component.componentId)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentWidth={String(componentProps.componentWidth)}
      componentStatus={String(componentProps.componentStatus)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
    >
      <input
        type="text"
        placeholder=""
        readOnly={true}
        value={valor}
      />
      <label>{titulo}</label>
    </Styles.TextInput>
  );
};
